import { ENGAGEMENT_CONFIG } from '../../shared/engagement/config';
import { rewardRuleList } from '../../shared/engagement/reward-presentation';

export function RewardRules({ currency, compact = false }: { currency: string; compact?: boolean }) {
  return <div className="study-reward-rules">
    <p className="stamp-rule">Mastery is the biggest reward.</p>
    <p>{ENGAGEMENT_CONFIG.stamps.startHereEarn}</p>
    <ul className="stamp-rule-list">{rewardRuleList(currency).map((rule) => <li key={rule}>{rule}</li>)}</ul>
    {!compact && <p>Balances and history from before this system started are kept as they were.</p>}
  </div>;
}
